import * as React from 'react';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon?: React.ElementType;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-16 px-8 text-center', className)}>
      {Icon && (
        <div className="mb-4 w-12 h-12 rounded-xl bg-cs-surface-raised border border-cs-border flex items-center justify-center">
          <Icon className="w-6 h-6 text-cs-text-muted" aria-hidden="true" />
        </div>
      )}
      <h3 className="text-sm font-semibold text-cs-text-secondary">{title}</h3>
      {description && (
        <p className="mt-1 text-sm text-cs-text-muted max-w-sm">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
